export default __webpack_public_path__ + "static/k_stark-453af431537760e2c4b248d7cf1d18f6.jpg";